var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmialIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #A7D379;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M800.16,492.53c0-4.48-1.81-8.97-5.08-12.24l-64.29-64.3v-133.88c0-9.58-7.77-17.34-17.34-17.34h-346.88c-9.58,0-17.34,7.76-17.34,17.34v133.88l-64.3,64.3c-.06.06-.11.13-.17.19-3.25,3.35-4.9,7.76-4.91,12.05,0,.01,0,.02,0,.03v312.18c0,28.73,23.37,52.03,52.03,52.03h416.25c28.72,0,52.03-23.36,52.03-52.03v-312.18s0-.02,0-.03ZM758.28,492.56l-27.5,27.5v-55.01l27.5,27.5ZM696.09,299.46v123.71h0v131.57l-93.9,93.9h-124.38l-93.9-93.9v-131.56h0v-123.72h312.19ZM349.22,520.06l-27.5-27.5,27.5-27.5v55.01ZM314.53,797.56v-263.13l131.57,131.57-131.57,131.57ZM339.06,822.09l138.75-138.75h124.38l138.75,138.75h-401.88ZM765.47,797.56l-131.57-131.57,131.57-131.57v263.13Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmialIcon);
export default __webpack_public_path__ + "static/media/emial-icon.18b8ed4177c0c0c0904b05a610f6e25f.svg";
export { ForwardRef as ReactComponent };